import { useLazyGetOfflineRequestsStatusQuery } from "../../../services/api/offlineApi";
import { useEffect, useRef, useState } from "react";
import { SyncingRequestStatusEnum } from "../../../services/api/types/offline/enums/SyncingRequestStatusEnum";

export function useShowSyncProgress() {
  const [isSyncProgressModalVisible, setIsSyncProgressModalVisible] =
    useState(false);
  const pollingRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const hasSeenProcessingRef = useRef(false);

  const [getOfflineRequestsStatus, { data, isLoading }] =
    useLazyGetOfflineRequestsStatusQuery();

  const clearPolling = () => {
    if (pollingRef.current) {
      console.log("Clearing interval", pollingRef.current);
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  };

  const startPolling = () => {
    console.log("startPolling called");
    clearPolling();
    pollingRef.current = setInterval(() => {
      console.log("Polling every 5s...");
      getOfflineRequestsStatus();
    }, 5000);

    console.log("pollingRef.current", pollingRef.current);
  };

  const stopPollingIfNoPendingRequests = () => {
    const hasPendingRequests = data?.some(
      (request) => request.status === SyncingRequestStatusEnum.PROCESSING,
    );

    if (hasPendingRequests) {
      hasSeenProcessingRef.current = true;
    }

    if (hasSeenProcessingRef.current && !hasPendingRequests) {
      clearPolling();
    }
  };

  const showSyncProgressModal = async () => {
    setIsSyncProgressModalVisible(true);
    hasSeenProcessingRef.current = false;

    const result = await getOfflineRequestsStatus().unwrap();

    const hasPendingRequests = result?.some(
      (request) => request.status === SyncingRequestStatusEnum.PROCESSING,
    );

    if (hasPendingRequests) {
      startPolling();
    } else {
      clearPolling();
    }
  };

  const hideSyncProgressModal = () => {
    setIsSyncProgressModalVisible(false);
    clearPolling();
  };

  useEffect(() => {
    if (isSyncProgressModalVisible) {
      stopPollingIfNoPendingRequests();
    }
  }, [data, isSyncProgressModalVisible]);

  return {
    isSyncProgressModalVisible,
    showSyncProgressModal,
    hideSyncProgressModal,
    data,
    isLoading,
  };
}
